import { render } from "./VariantsV2.vue?vue&type=template&id=8b251128&scoped=true"
import script from "./VariantsV2.vue?vue&type=script&lang=js"
export * from "./VariantsV2.vue?vue&type=script&lang=js"

import "./VariantsV2.vue?vue&type=style&index=0&id=8b251128&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b251128"]])

export default __exports__